import en from './en.js'
import ch from './ch.js'
export default {
  en,
  ch
}